import { getAPIUrl, getPath } from "../apiconfig";

import {
    TRANSLATION,
    LANG_IDS
} from "../util/Translation";

import { DOMAIN_BALDWIN, DOMAIN_TFS } from "../Constant";

import {
    // MIGRATION_AUTHENTICATE_URL,
    // MIGRATION_UPDATE_URL,
    // MIGRATION_FINISH_URL,
    // MIGRATION_TOKEN_URL,
    // MIGRATION_LOCALE_URL,
    // REACT_APP_AUTHORIZATION_KEY,
    // REACT_APP_PCM_AUTHORIZATION,
    // REACT_APP_PCMURL,
    // FOOTER_API,
    // CHANGEPASSWORD_URL
} from "../config/properties.js";

const axios = require('axios');
require('es6-promise').polyfill();

export function getLocaleInfo(func, pageName, langId) {
    try {

        // const url = MIGRATION_LOCALE_URL;
        const url =  getAPIUrl('getTranslations');
        const translations = [
            ...TRANSLATION.SIGN_IN_SCREEN,
            ...TRANSLATION.EMAIL_VERIFICATION_SCREEN,
            ...TRANSLATION.SUCCESS_SCREEN,
            ...TRANSLATION.UPDATE_PASSWORD_SCREEN,
            ...TRANSLATION.PASSWORD_SUCCESS_SCREEN
        ].join();

        const payload = {
            "translations": {
                "ids": translations,
                "locales": LANG_IDS[langId]
            }
        }
        const headers = {
            'Accept': 'application/json',
            'Content-Type': "application/json"
        }

        axios.post(url, payload, { headers: headers })
            .then((response) => {
                func(response);
            })
            .catch((error) => {

            });
    } catch (err) {

    }
}

export function migrationAuthenticate(func, username, password, langId) {
    try {
        // const url = MIGRATION_AUTHENTICATE_URL;
        const url= getAPIUrl("migrationAuthenticate");
        var headers = {
            'Accept': 'application/json',
            'Content-Type': "application/json"
        }
        const payload = {
            "logonId": String(username).toLowerCase(),
            "logonPassword": password,
            "langId": langId
        };

        /*fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: payload
        }).then(function (response) {
            return response.json()
        }).then(function (json) {
            console.log('parsed json', json)
        }).catch(function (ex) {
            console.log('parsing failed', ex)
        })*/

        axios.post(url, payload, { headers: headers })
            .then((response) => {
                func(response);
            })
            .catch((error) => {
                let errResponse = {
                    errors: [{ errorMessage: "" }]
                }
                if (error && error.response) {
                    errResponse = error.response.data
                }
                func(errResponse);
            });
    } catch (err) {
        return err;
    }
}

export function migrationUpdate(func, emailFieldValue, username, WCToken, WCTrustedToken, langId) {
    try {
        // const url = MIGRATION_UPDATE_URL
        const url = getAPIUrl('migrationUpdate');
        var headers = {
            'Accept': 'application/json',
            'Content-Type': "application/json"
        }
        const payload = {
            "username": String(username).toLowerCase(),
            "email": String(emailFieldValue).toLowerCase(),
            "langId": langId
        };

        axios.post(url, payload, { headers: headers })
            .then((response) => {
                func(response.data);
            })
            .catch((error) => {
                let errResp = {
                    errors: [{
                        errorMessage: "The User ID/Email you entered already exists. Kindly provide another value."
                    }]
                }
                if (error && error.response) {
                    errResp = error.response.data
                }
                func(errResp);
            });
    } catch (err) {
        return err;
    }
}

export function migrationFinish(func, newPassword, loginId, langId) {
    try {
        // const url = MIGRATION_FINISH_URL;
        //const url = getAPIUrl('migrationFinish')
        const url = getPath('getProxyUrl') + '/migrationFinish'; 

        //support for + symbol in VOM user email 12/4/20
        loginId = loginId.replace(/\+/g,"%2B");
        
        const payload = {
            "userEmail": String(loginId).toLowerCase(),
            "newPassword": newPassword,
            "langId": langId
        }
        
        axios.post(url, payload)
            .then((response) => {
                func(response);

            })
            .catch((error) => {
                let errResp = {
                    errorMessage: ""
                }
                if (error && error.response && error.response.data) {
                    errResp = {
                        errorMessage: error.response.data.message
                    }
                }
                func(errResp);
            });
    } catch (err) {
        return err;
    }

}

export function changePassword(func, newPassword, stateToken) {
    try {
        // const url = CHANGEPASSWORD_URL + loginId;
        // const url = getAPIUrl('changePassword');
        // var headers = {
        //     'Ocp-Apim-Subscription-Key': getPath('getOKTASubscriptionKey')
        // }
        
    const url = getPath('getProxyUrl') + '/change-password';
    // const url ='http://localhost:5000/api/change-password';
        const payload = {
            "stateToken": stateToken,
            "newPassword": newPassword
        }
        axios.post(url, payload)
            .then((response) => {
                func(response);
            })
            .catch((error) => {
                let errResp = {
                    errorMessage: ""
                }
                if (error && error.response && error.response.data) {
                    errResp = {
                        errorMessage: error.response.data.errorCauses[0].errorSummary
                    }
                }
                func(errResp);
            });
    } catch (err) {
        return err;
    }

}

export function addUserToGroup(func, userId, groupId, accessToken) {
    try {
        // const url = getAPIUrl('addUserToGroup').replace("#userid#", userId).replace("#groupid#", groupId);
        // var headers = {
        //     'Authorization': 'Bearer ' + accessToken,
        // }
        
    const url = getPath('getProxyUrl') + '/add-user-to-group?userid='+userId+'&groupid='+groupId;
    // const url ='http://localhost:5000/api/add-user-to-group?userid='+userId+'&groupid='+groupId;
    const payload = {"token":accessToken};

        axios.post(url, payload)
            .then((response) => {
                func(response);
            })
            .catch((error) => {
                let errResp = {
                    errorMessage: ""
                }
                if (error && error.response && error.response.data) {
                    errResp = {
                        errorMessage: error.response.data.message
                    }
                }
                func(errResp);
            });
    } catch (err) {
        return err;
    }

}

export function validateToken(func, token, langId) {
    try {
        // const url = MIGRATION_TOKEN_URL;
        const url = getAPIUrl('getTokenUrl');
        var headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        const payload = {
            "recoveryToken": token,
            "langId": langId
        }
        axios.post(url, payload, { headers: headers })
            .then((response) => {
                func(response);
            })
            .catch((error) => {
                let errResp = {
                    errorSummary: ""
                }
                if (error && error.response) {
                    errResp = error.response.data
                }
                func(errResp);
            });
    } catch (err) {
        return err;
    }
}


export function getPCMLink(userId, func) {
    try {
        // const url = getAPIUrl('getPCMUrl').replace('guid', userId);

        // var headers = {
        //     'Accept': 'application/json',
        //     'Content-Type': 'application/json',
        //     'Ocp-Apim-Subscription-Key': getPath('getOKTASubscriptionKey')
        // }
        
    const url = getPath('getProxyUrl') +"/get-group-from-user?userid="+ userId
    // const url = "http://localhost:5000/api/get-group-from-user?userid="+ userId

        axios.get(url)
            .then((response) => {
                func(response);
            })
            .catch((error) => {
                let errResp = {
                    errorSummary: ""
                }
                if (error && error.response) {
                    errResp = error.response.data
                }
                func(errResp);
            });
    } catch (err) {
        return err;
    }
}

export function callSmartCommAPI(obj) {
    //const { langId, history } = this.props.contextProps;
    const inputData = window.btoa(new XMLSerializer().serializeToString(obj));

    const postData = {
      name: "Okta_Email_" + Date.now(),
      inputData: inputData,
      project: "-1",
      //project: "157775803",
      config: "157862427",
      range: "1",
      queue: getPath("getSmartCommQueue"),
    };

    //user has be created at this point (work on custom email for approval flow ex. "Your Parker account has been create but awaiting approval for [appname]...")
    //send user confirmation email to activate account
    // axios({
    //   method: "post",
    //   // url: 'https://apidev.parker.com/dev/smartcomm/api/v5/jobs',
    //   url: getAPIUrl("getJobsAPIUrl"),
    //   headers: {
    //     "Ocp-Apim-Subscription-Key": getPath("getJObAPIOCMSubscriptionKey")
    //   },

    //   data: postData,
    // })
    
         const url = getPath('getProxyUrl') + "/send-email"
        //  const url = "http://localhost:5000/api/send-email"
    axios.post(url, postData)
      .then((resp) => {
        //console.log(resp);
        if (resp && resp.status === 201) {
            //complete
        } else {
            //other
        }
      })
      .catch((err) => {
        //console.log(err);
      });
  }
 export function callSendEmailAPI(inputData){
     let url = getPath('getProxyUrl') + "/send-template-email";
    axios.post(url, inputData)
     .then((resp) => {
        //console.log(resp);
        if (resp && resp.status === 200) {
            //complete
            return;
        } else {
            //other
            return;
        }
      })
      .catch((err) => {
        console.log(err);
        return;
      });
 }
export const createOktaEmailObject = (type, obj, token, domainName, appId, applicationName= '') => {

    const doc = document.implementation.createDocument("", "", null);
    const oktaemail = doc.createElement("oktaemail");

    const emailsettings = doc.createElement("emailsettings");

    const imagesource = doc.createElement('imagesource');
    if (domainName === DOMAIN_TFS)
    {
        imagesource.textContent = "https://www.totalfiltrationservices.com/parker/TFS/assets/images/logo.png";
    }
    else if (domainName === DOMAIN_BALDWIN)
    {
        imagesource.textContent = "https://ph.baldwinfilters.com/wcsstore/ParkerB2BStorefrontAssetStore/images/baldwinlogo.jpg";
    }
    else
    {
        imagesource.textContent = "https://ph.parker.com/wcsstore/ParkerAuroraStorefrontAssetStore/images/logo.jpg";
    }   
    emailsettings.appendChild(imagesource);

    const color = doc.createElement('color');
    if (domainName === DOMAIN_TFS)
    {
        color.textContent = "#211F5F"
    }
    else if (domainName === DOMAIN_BALDWIN)
    {
        color.textContent = "#ED1C24"
    }
    else
    {
        color.textContent = "#E2AA11"
    }  
    emailsettings.appendChild(color);

    const emailType = doc.createElement('emailtype');
    if (type === 'register') {
        if (appId != '')
        {
            emailType.textContent = "access"; //this is a blank template email with just a text body
        }
        else
        {
            emailType.textContent = "activate";
        }     
    } else if (type === 'reset-password') {
        emailType.textContent = "reset";
    }
    emailsettings.appendChild(emailType);
    oktaemail.appendChild(emailsettings);

    const emailInformation = doc.createElement("emailinformation");
    const leanerAppId = getPath("getLeanerAppId");
    if(appId != '')
    {
        //update this to get app name dynamically
        const appName = leanerAppId === appId ? "PLI application" : applicationName;
        const bodyText = doc.createElement('bodytext');
        bodyText.textContent = 'Your access to '+ appName +' is currently pending approval and you will be notified by email when an action is taken.';
        emailInformation.appendChild(bodyText);

        const approveusername = doc.createElement('approveusername');
        approveusername.textContent = obj.emailFieldValue;
        emailInformation.appendChild(approveusername);
    }

    const fromName = doc.createElement('fromname');
    if (domainName === DOMAIN_TFS)
    {
        fromName.textContent = 'TFS Support';
    }
    else if (domainName === DOMAIN_BALDWIN)
    {
        fromName.textContent = 'Baldwin Filters Support';
    }
    else
    {
        fromName.textContent = 'Parker Support';
    }  
    emailInformation.appendChild(fromName);

    const fromEmail = doc.createElement('fromemail');
    if (domainName === DOMAIN_TFS)
    {
        fromEmail.textContent = getPath('getTFSEmailId');
    }
    else if (domainName === DOMAIN_BALDWIN)
    {
        fromEmail.textContent = getPath('getBaldwinEmailId');
    }
    else
    {
        fromEmail.textContent = getPath('getEmail');
    }    
    emailInformation.appendChild(fromEmail);

    const toName = doc.createElement('toname');
    toName.textContent = obj.userFirstName;
    emailInformation.appendChild(toName);
    const toEmail = doc.createElement('toemail');
    toEmail.textContent = obj.emailFieldValue;
    emailInformation.appendChild(toEmail);

    if (type === 'register') {
        const subject = doc.createElement('subject');
        subject.textContent = 'Activate Account';
        if(appId != '')
        {
            subject.textContent = `Pending Approval to ${leanerAppId === appId ? `PLI Application` : applicationName}`;
        }
        else
        {
            const activationLink = doc.createElement('activationlink');
            activationLink.textContent = token;
            emailInformation.appendChild(activationLink);
        }
        emailInformation.appendChild(subject);

    } else if (type === 'reset-password') {
        const subject = doc.createElement('subject');
        subject.textContent = 'Account password reset';
        emailInformation.appendChild(subject);

        const resetlink = doc.createElement('resetlink');
        if (domainName === DOMAIN_TFS)
        {
            resetlink.textContent = getPath('redirectUrlTfs') + '/?mode=1&updatepassword=' + token;
        }
        else if (domainName === DOMAIN_BALDWIN)
        {
            resetlink.textContent =  getPath('redirectUrlBaldwin') + '/?mode=1&updatepassword=' + token;
        }
        else
        {
            resetlink.textContent = getPath('redirectUrl') + '/?mode=1&updatepassword=' + token;
        }    
        emailInformation.appendChild(resetlink);
    }

    if(appId === '')
    {
        const linkExpiration = doc.createElement('linkexpiration');
        linkExpiration.textContent = '7 days';
        emailInformation.appendChild(linkExpiration);
    
        const username = doc.createElement('username');
        username.textContent = obj.emailFieldValue;
        emailInformation.appendChild(username);
    
        const helpLink = doc.createElement('helplink');
        if (domainName === DOMAIN_TFS)
        {
            helpLink.textContent = getPath('redirectUrlTfs') + '/help/login';
        }
        else if (domainName === DOMAIN_BALDWIN)
        {
            helpLink.textContent = getPath('redirectUrlBaldwin') + '/help/login';
        }
        else
        {
            helpLink.textContent = getPath('redirectUrl') + '/help/login';
        } 
        emailInformation.appendChild(helpLink);
    }

    const orgname = doc.createElement('orgname');
    if (domainName === DOMAIN_TFS)
    {
        orgname.textContent = 'TFS';
    }
    else if (domainName === DOMAIN_BALDWIN)
    {
        orgname.textContent = 'Baldwin Filters';
    }
    else
    {
        orgname.textContent = 'Parker';
    }  
    emailInformation.appendChild(orgname);

    const orglink = doc.createElement('orglink');
    if (domainName === DOMAIN_TFS)
    {
        orglink.textContent = getPath('getTFSHomePage');
    }
    else if (domainName === DOMAIN_BALDWIN)
    {
        orglink.textContent = getPath('getBaldwinHomePage');
    }
    else
    {
        orglink.textContent = getPath('getParkerHomePage') ;
    } 
    emailInformation.appendChild(orglink);

    oktaemail.appendChild(emailInformation);
    doc.appendChild(oktaemail);
    //console.log(doc);
    return doc;
}

export const createOktaEmailObject_Approval = (type, obj, approveremail, approverfname, appId, applicationName='') => {

    const doc = document.implementation.createDocument("", "", null);
    const oktaemail = doc.createElement("oktaemail");

    const emailsettings = doc.createElement("emailsettings");

    const imagesource = doc.createElement('imagesource');
    imagesource.textContent = "https://ph.parker.com/wcsstore/ParkerAuroraStorefrontAssetStore/images/logo.jpg";
    emailsettings.appendChild(imagesource);

    const color = doc.createElement('color');
    color.textContent = "#E2AA11"
    emailsettings.appendChild(color);

    const emailType = doc.createElement('emailtype');
    emailType.textContent = "approve";
    emailsettings.appendChild(emailType);
    oktaemail.appendChild(emailsettings);

    const emailInformation = doc.createElement("emailinformation");

    const fromName = doc.createElement('fromname');
    fromName.textContent = 'Parker Support';
    emailInformation.appendChild(fromName);

    const fromEmail = doc.createElement('fromemail');
    fromEmail.textContent = getPath('getEmail');    
    emailInformation.appendChild(fromEmail);

    const toName = doc.createElement('toname');
    toName.textContent = approverfname;
    emailInformation.appendChild(toName);

    const toEmail = doc.createElement('toemail');
    toEmail.textContent = approveremail;
    emailInformation.appendChild(toEmail);

    //update to dynmaically get app ID
    const subject = doc.createElement('subject');
    const leanerAppId = getPath("getLeanerAppId");
    subject.textContent = leanerAppId === appId ? 'Approve Account - PLI Application' : `Approve Account - ${applicationName}`;
    emailInformation.appendChild(subject);

    const orgname = doc.createElement('orgname');
    orgname.textContent = 'Parker';
    emailInformation.appendChild(orgname);

    const orglink = doc.createElement('orglink');
    orglink.textContent = getPath('getParkerHomePage'); 
    emailInformation.appendChild(orglink);

    const appname = doc.createElement('appname');
    appname.textContent = leanerAppId === appId ? 'PLI application' : applicationName;
    emailInformation.appendChild(appname);

    const approveusername = doc.createElement('approveusername');
    approveusername.textContent = obj.emailFieldValue;
    emailInformation.appendChild(approveusername);

    const approvename = doc.createElement('approvename');
    approvename.textContent = obj.userFirstName + ' ' + obj.userLastName;
    emailInformation.appendChild(approvename);

    const approveorgname = doc.createElement('approveorgname');
    approveorgname.textContent = obj.orgValue;
    emailInformation.appendChild(approveorgname);
    
    if (obj.areaOfInterestText) {
        const areaofinterest = doc.createElement('areaofinterest');
        areaofinterest.textContent = obj.areaOfInterestText;
        emailInformation.appendChild(areaofinterest);
    }

    const denylink = doc.createElement('denylink');  
    const approvelink = doc.createElement('approvelink');

    const userid = obj.id;
    let groupid;
    if (appId === getPath("getLeanerAppId")) {
        groupid = getPath('getPLIGroupId');
    } else {
        groupid = getPath('getParkerIdGroupId');
    }
    denylink.textContent = getPath('getBaseReactUrl') + "/deny/" + userid+ "/" + groupid + "/" + appId;
    approvelink.textContent = getPath('getBaseReactUrl') + "/approve/" + userid + "/" + groupid+ "/" + appId;
    emailInformation.appendChild(denylink);
    emailInformation.appendChild(approvelink); 

    oktaemail.appendChild(emailInformation);
    doc.appendChild(oktaemail);

    return doc;
}


export const createOktaEmailObject_Access = (username, fname, appName, link) => {

    const doc = document.implementation.createDocument("", "", null);
    const oktaemail = doc.createElement("oktaemail");

    const emailsettings = doc.createElement("emailsettings");

    const imagesource = doc.createElement('imagesource');
    imagesource.textContent = "https://ph.parker.com/wcsstore/ParkerAuroraStorefrontAssetStore/images/logo.jpg";
    emailsettings.appendChild(imagesource);

    const color = doc.createElement('color');
    color.textContent = "#E2AA11"
    emailsettings.appendChild(color);

    const emailType = doc.createElement('emailtype');
    emailType.textContent = "access";
    emailsettings.appendChild(emailType);
    oktaemail.appendChild(emailsettings);

    const emailInformation = doc.createElement("emailinformation");

    const fromName = doc.createElement('fromname');
    fromName.textContent = 'Parker Support';
    emailInformation.appendChild(fromName);

    const fromEmail = doc.createElement('fromemail');
    fromEmail.textContent = getPath('getEmail');    
    emailInformation.appendChild(fromEmail);

    const toName = doc.createElement('toname');
    toName.textContent = fname;
    emailInformation.appendChild(toName);

    const toEmail = doc.createElement('toemail');
    toEmail.textContent = username;
    emailInformation.appendChild(toEmail);

    //update to dynmaically get app ID, approve or deny flag needed
    const subject = doc.createElement('subject');
    if(link === "deny")
    {
        subject.textContent = 'Access Denied to ' + appName;
    }
    else
    {
        subject.textContent = 'Access Granted to ' + appName;
    }
    emailInformation.appendChild(subject);

    const bodyText = doc.createElement('bodytext');
    if(link === "deny")
    {
        bodyText.textContent = 'Your account has been denied access to '+ appName +'.';
    }
    else
    {
        bodyText.textContent = 'Your account has been granted access to '+ appName +'. Click the below button to access '+ appName +'.';
    }   
    emailInformation.appendChild(bodyText);

    const orgname = doc.createElement('orgname');
    orgname.textContent = 'Parker';
    emailInformation.appendChild(orgname);

    const orglink = doc.createElement('orglink');
    orglink.textContent = getPath('getParkerHomePage'); 
    emailInformation.appendChild(orglink);

    const appname = doc.createElement('appname');
    appname.textContent = appName;
    emailInformation.appendChild(appname);

    const approveusername = doc.createElement('approveusername');
    approveusername.textContent = username;
    emailInformation.appendChild(approveusername);

    const approvelink = doc.createElement('approvelink');
    if(link != "deny")
    {
        approvelink.textContent = link;
        emailInformation.appendChild(approvelink); 
    }    
    

    oktaemail.appendChild(emailInformation);
    doc.appendChild(oktaemail);

    return doc;
}

export function getOktaEmailTemplateDetails(type, obj, token, domainName, appId, applicationName = '') {
    let emailMethodType;
    type == 'reset-password' ? emailMethodType = "oktaEmailTemplateReset" : emailMethodType = "oktaEmailTemplateRegister";
    const leanerAppId = getPath("getLeanerAppId");

    // Images
    let imageSource;
    if (domainName === DOMAIN_TFS) {
        imageSource = "";
    } else if (domainName === DOMAIN_BALDWIN) {
        imageSource = "";
    } else {
        imageSource = "";
    }

    // Colors
    let color;
    if (domainName === DOMAIN_TFS) {
        color = "#211F5F";
    } else if (domainName === DOMAIN_BALDWIN) {
        color = "#ED1C24";
    } else {
        color = "#FFB91D";
    }

    // Email type
    let emailType;
    if (type === 'register') {
        emailType = appId !== '' ? "access" : "activate";
    } else if (type === 'reset-password') {
        emailType = "reset";
    }

    // From name/email
    let fromName, fromEmail;
    if (domainName === DOMAIN_TFS) {
        fromName = 'TFS Support';
        fromEmail = getPath('getTFSEmailId');
    } else if (domainName === DOMAIN_BALDWIN) {
        fromName = 'Baldwin Filters Support';
        fromEmail = getPath('getBaldwinEmailId');
    } else {
        fromName = 'Parker Support';
        fromEmail = getPath('getEmail');
    }

    // To name/email
    const toName = obj.userFirstName;
    const toEmail = obj.emailFieldValue;

    // App name
    const appName = appId !== '' ? (leanerAppId === appId ? "PLI application" : applicationName) : "";

    // Body text
    let bodyText = '';
    if (appId !== '') {
        bodyText = `Your access to ${appName} is currently pending approval and you will be notified by email when an action is taken.`;
    }

    // Approve username
    const approveUsername = appId !== '' ? obj.emailFieldValue : null;

    // Subject and activation/reset links
    let subject = '';
    let activationLink = null;
    let resetLink = null;
    if (type === 'register') {
        subject = appId !== '' ?
            `Pending Approval to ${leanerAppId === appId ? 'PLI Application' : applicationName}` :
            'Activate Account';
        if (appId === '') {
            activationLink = token;
        }
    } else if (type === 'reset-password') {
        subject = 'Account password reset';
        if (domainName === DOMAIN_TFS) {
            resetLink = getPath('redirectUrlTfs') + '/?mode=1&updatepassword=' + token;
        } else if (domainName === DOMAIN_BALDWIN) {
            resetLink = getPath('redirectUrlBaldwin') + '/?mode=1&updatepassword=' + token;
        } else {
            resetLink = getPath('redirectUrl') + '/?mode=1&updatepassword=' + token;
        }
    }

    // Link expiration, username, help link (only if appId is empty)
    let linkExpiration = null, username = null, helpLink = null;
    if (appId === '') {
        emailMethodType = 'activateAccountEmail';
        linkExpiration = '7 days';
        username = obj.emailFieldValue;
        if (domainName === DOMAIN_TFS) {
            helpLink = getPath('redirectUrlTfs') + '/help/login';
        } else if (domainName === DOMAIN_BALDWIN) {
            helpLink = getPath('redirectUrlBaldwin') + '/help/login';
        } else {
            helpLink = getPath('redirectUrl') + '/help/login';
        }
    }

    // Org name/link
    let orgName, orgLink;
    if (domainName === DOMAIN_TFS) {
        orgName = 'TFS';
        orgLink = getPath('getTFSHomePage');
    } else if (domainName === DOMAIN_BALDWIN) {
        orgName = 'Baldwin Filters';
        orgLink = getPath('getBaldwinHomePage');
    } else {
        orgName = 'Parker';
        orgLink = getPath('getParkerHomePage');
    }
    let accountDomain = domainName;
    return {
        emailMethodType,
        imageSource,
        color,
        emailType,
        fromName,
        fromEmail,
        toName,
        toEmail,
        appName,
        bodyText,
        approveUsername,
        subject,
        activationLink,
        resetLink,
        linkExpiration,
        username,
        helpLink,
        orgName,
        orgLink,
        accountDomain
    };
}
export function getApprovalEmailTemplateDetails(type, obj, approveremail, approverfname, appId, applicationName = '') {
    const emailMethodType = "approveOrDenyEmail";
    const imageSource = "";
    const color = "#E2AA11";
    const emailType = "approve";
    const fromName = "Parker Support";
    const fromEmail = getPath('getEmail');
    const toName = approverfname;
    const toEmail = approveremail;
    const leanerAppId = getPath("getLeanerAppId");
    const subject = leanerAppId === appId ? 'Approve Account - PLI Application' : `Approve Account - ${applicationName}`;
    const orgName = "Parker";
    const orgLink = getPath('getParkerHomePage');
    const appName = leanerAppId === appId ? 'PLI application' : applicationName;
    const approveUsername = obj.emailFieldValue;
    const approveName = obj.userFirstName + ' ' + obj.userLastName;
    const approveOrgName = obj.orgValue;
    const areaOfInterest = obj.areaOfInterestText ? obj.areaOfInterestText : null;

    // Links
    const userId = obj.id;
    let groupId;
    if (appId === leanerAppId) {
        groupId = getPath('getPLIGroupId');
    } else {
        groupId = getPath('getParkerIdGroupId');
    }
    const denyLink = getPath('getBaseReactUrl') + "/deny/" + userId + "/" + groupId + "/" + appId;
    const approveLink = getPath('getBaseReactUrl') + "/approve/" + userId + "/" + groupId + "/" + appId;

    // Return all variables
    return {
        emailMethodType,
        imageSource,
        color,
        emailType,
        fromName,
        fromEmail,
        toName,
        toEmail,
        subject,
        orgName,
        orgLink,
        appName,
        approveUsername,
        approveName,
        approveOrgName,
        areaOfInterest,
        denyLink,
        approveLink
    };
}

export function getAccessEmailTemplateDetails(username, fname, appName, link) {
    const emailMethodType = "accessGrantedOrDeniedEmail";
    const imageSource = "";
    const color = "#E2AA11";
    const emailType = "access";
    const fromName = "Parker Support";
    const fromEmail = getPath('getEmail');
    const toName = fname;
    const toEmail = username;

    // Subject and body text based on link value
    const subject = link === "deny"
        ? `Access Denied to ${appName}`
        : `Access Granted to ${appName}`;

    const bodyText = link === "deny"
        ? `Your account has been denied access to ${appName}.`
        : `Your account has been granted access to ${appName}. Click the below button to access ${appName}.`;

    const orgName = "Parker";
    const orgLink = getPath('getParkerHomePage');
    const approveUsername = username;
    const appname = appName;
    const approveLink = link !== "deny" ? link : null;

    return {
        emailMethodType,
        imageSource,
        color,
        emailType,
        fromName,
        fromEmail,
        toName,
        toEmail,
        subject,
        bodyText,
        orgName,
        orgLink,
        appname,
        approveUsername,
        approveLink
    };
}

function getForgotPasswordTemplateDetails(domainName) {
    let subject = "- Password Reset Requested", helpLink, orgLink, resetLink, accountDomain, color;
    
    if(domainName == DOMAIN_TFS){
        subject = "TFS "+ subject;
        helpLink = getPath('redirectUrlTfs') + '/help/login';
        orgLink = getPath('getTFSHomePage');
        resetLink = getPath('redirectUrlTfs') + '/?resettoken=';
        accountDomain = "TFS";
        color= "#211f5f"
    }else if(domainName == DOMAIN_BALDWIN){
        subject = "Baldwin Filters "+ subject;
        helpLink = getPath('redirectUrlBaldwin') + '/help/login';
        orgLink = getPath('getBaldwinHomePage');
        resetLink = getPath('redirectUrlBaldwin') + '/?mode=1&updatepassword=';
        accountDomain = "Baldwin Filters";
        color= "#ed1c24"
    }else{
        subject = "MyParker "+ subject;
        helpLink = getPath('redirectUrl') + '/help/login';
        orgLink = getPath('getMyParkerDashBoardURL');
        resetLink = getPath('redirectUrl') + '/?recoveryToken=';
        accountDomain = "MyParker";
        color= "#FFB91D"
    }

    return{
        subject,
        helpLink,
        orgLink,
        resetLink,
        accountDomain,
        color
    }
}
export const FetchFooterDetails = (langCode, func) => {
    // const url = FOOTER_API + "?divisionId=350455&langId=" + langCode
    const url = getAPIUrl('getFooterUrl')+"?divisionId=350455&langId=" + langCode;

    axios.get(url)
        .then((response) => {
            const { result } = response.data;
            const staticFooter = result.staticFooter;
            func(staticFooter);
        })
        .catch((error) => {
            console.log("Error: ", error);
        });
}


export const DeleteUser = (userId, accessToken, func) => {
    try {
        // const url = getAPIUrl('getUserDetails') + userId + '/';
        var headers = {
            'authorization-token': 'Bearer ' + accessToken,
        }

         const url = getPath('getProxyUrl') + "/delete-user?userid="+ userId
        //  const url = "http://localhost:5000/api/delete-user?userid="+userId
        axios.delete(url, { headers: headers })
            .then((response) => {
                func(response);
            })
            .catch((error) => {
                let errResp = {
                    errorMessage: ""
                }
                if (error && error.response && error.response.data) {
                    errResp = {
                        errorMessage: error.response.data.message
                    }
                }
                func(errResp);
            });

    } catch (err) {
        return err;
    }
}


/****
 * 
 * REGISTRATION APIS
 * 
 */

export const registerUser = (userInfo, domainName, fn) => {
    // const url = 'https://apidev.parker.com/test/okta/users?activate=false'
    // const url = getAPIUrl('getRegisterUrl');
    // var headers = {
    //     'Ocp-Apim-Subscription-Key': getPath('getOKTASubscriptionKey')
    // }
    const url = getPath('getProxyUrl') + '/pli-registration';
    // const url ='http://localhost:5000/api/pli-registration';


    const payload = {
        "profile": {
            "firstName": userInfo.userFirstName,
            "lastName": userInfo.userLastName,
            "email": userInfo.emailFieldValue,
            "login": userInfo.emailFieldValue
        },
        "credentials": {
            "password": { "value": userInfo.passwordValue }
        },
        "groupIds": [
            getPath('getParkerGroupId'),
            //add additional group id based on domain
            domainName === DOMAIN_TFS ? getPath('getTFSGroupId') : domainName === DOMAIN_BALDWIN ? getPath('getBaldwinGroupId') : ''
        ]
    }

    axios.post(url, payload)
        .then((response) => {
            const resp = response.data;
            fn(resp);
        })
        .catch((err) => {
            let errResp = {
                errorSummary: ""
            }
            if (err && err.response) {
                errResp = err.response.data;
            }
            fn(errResp)
        });

}

export const activateUser = (userGuid, fn) => {
    // const url = 'https://apidev.parker.com/test/okta/users/' + userGuid + '/lifecycle/activate?sendEmail=false'
    // const url = getAPIUrl('getActivateUrl').replace("#userGuid#", userGuid);
    // var headers = {
    //     'Ocp-Apim-Subscription-Key': getPath('getOKTASubscriptionKey')
    // }
    const url = getPath('getProxyUrl') + '/activate-user?userGuid='+ userGuid;
    // const url = 'http://localhost:5000/api/activate-user?userGuid='+ userGuid;
    axios.post(url)
        .then((response) => {
            const resp = response.data;
            fn(resp);
        })
        .catch((err) => {
            let errResp = {
                errorSummary: ""
            }
            if (err && err.response) {
                errResp = err.response.data;
            }
            fn(errResp)
        });

}

export const getUsersFromGroup = (groupID, fn) => {
    // const url = getAPIUrl('getUsersFromGroup').replace("#groupid#", groupID);
    // var headers = {
    //     'Ocp-Apim-Subscription-Key': getPath('getOKTASubscriptionKey')
    // }
    const url = getPath('getProxyUrl') + '/get-users-from-group?groupId='+ groupID;
    // const url = 'http://localhost:5000/api/get-users-from-group?groupId='+ groupID;
    axios.get(url)
        .then((response) => {
            const resp = response.data;
            fn(resp);
        })
        .catch((err) => {
            let errResp = {
                errorSummary: ""
            }
            if (err && err.response) {
                errResp = err.response.data;
            }
            fn(errResp)
        });

}

export const getGroupsFromUser = (userID, fn) => {
    // const url = getAPIUrl('getGroupsFromUser').replace("#userid#", userID);

    // var headers = {
    //     'Ocp-Apim-Subscription-Key': getPath('getOKTASubscriptionKey')
    // }
    
    const url = getPath('getProxyUrl') +"/get-group-from-user?userid="+ userID
    // const url = "http://localhost:5000/api/get-group-from-user?userid="+ userID
    axios.get(url)
        .then((response) => {
            const resp = response.data;
            fn(resp);
        })
        .catch((err) => {
            let errResp = {
                errorSummary: ""
            }
            if (err && err.response) {
                errResp = err.response.data;
            }
            fn(errResp)
        });

}

export const getAppInfo = (appID, fn) => {
    // const url = getAPIUrl('getAppInfo').replace("#appid#", appID);

    // var headers = {
    //     'Ocp-Apim-Subscription-Key': getPath('getOKTASubscriptionKey')
    // }
    const url = getPath('getProxyUrl') +"/get-app-info?appId="+ appID
    // const url = "http://localhost:5000/api/get-app-info?appId="+ appID
    axios.get(url)
        .then((response) => {
            const resp = response.data;
            fn(resp);
        })
        .catch((err) => {
            let errResp = {
                errorSummary: ""
            }
            if (err && err.response) {
                errResp = err.response.data;
            }
            fn(errResp)
        });
}

export const getCurrentUser = (fn) => {
    const url = getAPIUrl('getCurrentUser');

    axios.get(url,{withCredentials: true})
        .then((response) => {
            const resp = response.data;
            fn(resp);
        })
        .catch((err) => {
            let errResp = {
                errorSummary: ""
            }
            if (err && err.response) {
                errResp = err.response.data;
            }
            fn(errResp)
        });

}

/****
 * 
 * Forgot Password APIS
 * 
 */
export const getUserDetails = (userEmail, accessToken, fn) => {
    // const url = 'https://apidev.parker.com/test/okta/users/' + userEmail;
    const url = getPath('getProxyUrl') +'/getUserDetails';
    let body = {
        userEmail: btoa(userEmail)
    }
    let headers = {
        'Authorization': 'Bearer ' + accessToken
    }
    axios.post(url, body, { headers: headers })
        .then((response) => {
            const resp = response.data;
            fn(resp);
        })
        .catch((err) => {
            let errResp = {
                errorSummary: ""
            }
            if (err && err.response) {
                errResp = err.response.data;
            }
            fn(errResp)
        });

}

export const forgotPassword = (userEmail, domainName, fn) => {
    
    // const url = getAPIUrl('getForgortPassword').replace("#userEmail#", userEmail).replace("#domainName#",  domainName === DOMAIN_TFS ? 'TFS' : domainName === DOMAIN_BALDWIN ? 'Baldwin' : 'MyParker');

    // var headers = {
    //     'Accept': 'application/json',
    //     'Content-Type': "application/json",
    //     'Ocp-Apim-Subscription-Key': getPath('getOKTASubscriptionKey')
    // }
    const url = getPath('getProxyUrl') + '/forgotPassword';
    let body = {
        userEmail: userEmail,
        domainName: domainName === DOMAIN_TFS ? 'TFS' : domainName === DOMAIN_BALDWIN ? 'Baldwin' : 'MyParker'
    }
    axios.post(url, body)
        .then((response) => {
            const resp = response.data;
            fn(resp);
        })
        .catch((err) => {
            let errResp = {
                errorSummary: ""
            }
            if (err && err.response) {
                errResp = err.response.data;
            }
            fn(errResp)
        });

}

export const mpLoginForgotPassword = (userEmail, domainName, fn) => {
    try {
        const url = getPath('getProxyUrl') + '/mpLoginForgotPassword';
        let templateDetails = getForgotPasswordTemplateDetails(domainName);
        //domainName = domainName === DOMAIN_TFS ? 'TFS' : domainName === DOMAIN_BALDWIN ? 'Baldwin' : 'MyParker'
        let body = {
            userEmail: btoa(userEmail),
            domainName: btoa(domainName),
            templateDetails: templateDetails
        }
        axios.post(url, body)
            .then((response) => {
                const resp = response?.data;
                fn(resp);
            })
            .catch((err) => {
                let errResp = {
                    errStatus: 500,
                    errorData: {}
                }
                if (err && err.response) {
                    errResp.errStatus = err?.response?.status;
                    errResp.errorData = err?.response?.data;
                }
                fn(errResp)
            });
    } catch (err) {
        return err;
    }

}
export function addUserToSaba(payload) {
    try {
        // const url = getAPIUrl('addUserToSaba');
        // var headers = {
        //     'Ocp-Apim-Subscription-Key': getPath("getPLISubscriptionKey"),
        //     'Content-Type': 'application/json'
        // }

        const url = getPath('getProxyUrl') + "/add-user-to-saba"
        // const url = "http://localhost:5000/api/add-user-to-saba"
        axios.post(url, payload);
    } catch (err) {
        console.log(err);
    }
}

export function deleteUserToSaba(id) {
    try {
        // const url = getAPIUrl('deleteUserToSaba')+'?id='+id;
        // var headers = {
        //     'Ocp-Apim-Subscription-Key': getPath("getPLISubscriptionKey"),
        //     'Content-Type': 'application/json'
        // }

         const url = getPath('getProxyUrl') + "/delete-user-from-saba?id="+ id
        // const url = "http://localhost:5000/api/delete-user-from-saba/id="+id
        axios.delete(url);
    } catch (err) {
        console.log(err);
    }
}
